export default {
  SET_BENEFICIARIES: 'SET_BENEFICIARIES',
  CLEAR_BENEFICIARIES: 'CLEAR_BENEFICIARIES',
  ADD_BENEFICIARY: 'ADD_BENEFICIARY',
  EDIT_BENEFICIARY: 'EDIT_BENEFICIARY',
  SET_QUOTE: 'SET_QUOTE',
  UPSERT_QUOTE: 'UPSERT_QUOTE',
  REMOVE_QUOTE: 'REMOVE_QUOTE',
  CLEAR_QUOTE: 'CLEAR_QUOTE',
}
